module.exports = __webpack_public_path__ + "img/logo.71edec2d.svg";